export default {
  route: {
    Student: '学生管理',
    StudentList: '学生列表'
  },

  '学生管理': '学生管理',
  '学生列表': '学生列表',
  '添加学生': '添加学生',
  '请输入学生姓名或学号': '请输入学生姓名或学号',
  '请输入学生姓名、手机号或留言详情': '请输入学生姓名、手机号或留言详情',
  '删除选中': '删除选中',
  '状态': '状态',
  '搜索': '搜索',
  '清空': '清空',
  '启用': '启用',
  '禁用': '禁用',
  '操作': '操作',
  '详情': '详情',
  '删除': '删除',
  '学生详情': '学生详情',

  'ID': 'ID',
  '姓名': '姓名',
  '学号': '学号',
  '年龄': '年龄',
  '性别': '性别',
  '男': '男',
  '女': '女',
  '班级': '班级',
  '手机号': '手机号',
  '邮箱': '邮箱',
  '留言详情': '留言详情',
  '创建时间': '创建时间',
  '时间': '时间',

  '请输入学生姓名': '请输入学生姓名',
  '请输入学号': '请输入学号',
  '请输入学号（可选）': '请输入学号（可选）',
  '请输入年龄': '请输入年龄',
  '请输入班级': '请输入班级',
  '请输入班级（可选）': '请输入班级（可选）',
  '请输入手机号': '请输入手机号',
  '请输入邮箱': '请输入邮箱',
  '请输入邮箱（可选）': '请输入邮箱（可选）',
  '请输入留言详情（可选）': '请输入留言详情（可选）',
  '请输入正确的邮箱格式': '请输入正确的邮箱格式',

  '确认要删除该学生吗？': '确认要删除该学生吗？',
  '确认要删除选中的学生吗？': '确认要删除选中的学生吗？',
  '请选择要删除的学生': '请选择要删除的学生',
  '删除选择的学生成功': '删除选择的学生成功',
  '学生添加成功': '学生添加成功',
  '学生删除成功': '学生删除成功',
  '学生信息不存在': '学生信息不存在',
  '学生ID不能为空': '学生ID不能为空',
  '学生姓名不能为空': '学生姓名不能为空',
  '学号不能为空': '学号不能为空',
  '年龄必须在1-100之间': '年龄必须在1-100之间',
  '手机号不能为空': '手机号不能为空',
  '邮箱不能为空': '邮箱不能为空',

  '取消': '取消',
  '确定': '确定',
  '提示': '提示',

  '批量导入': '批量导入',
  '批量导入学生': '批量导入学生',
  '批量导入结果': '批量导入结果',
  'CSV文件格式说明': 'CSV文件格式说明',
  'CSV文件应包含以下字段（按顺序）：': 'CSV文件应包含以下字段（按顺序）：',
  '客户名称、手机号、微信、详细咨询信息': '客户名称、手机号、微信、详细咨询信息',
  '注意：第一行为表头，将从第二行开始导入数据': '注意：第一行为表头，将从第二行开始导入数据',
  '将CSV文件拖到此处，或': '将CSV文件拖到此处，或',
  '点击上传': '点击上传',
  '只能上传CSV文件，且不超过10MB': '只能上传CSV文件，且不超过10MB',
  '开始导入': '开始导入',
  '导入完成': '导入完成',
  '成功': '成功',
  '失败': '失败',
  '条': '条',
  '失败详情': '失败详情',
  '行号': '行号',
  '客户名称': '客户名称',
  '失败原因': '失败原因',
  '请上传CSV文件': '请上传CSV文件',
  '文件格式不正确，请上传CSV文件': '文件格式不正确，请上传CSV文件',
  'CSV文件至少需要包含表头和一行数据': 'CSV文件至少需要包含表头和一行数据',
  'CSV格式错误：字段数量不足': 'CSV格式错误：字段数量不足',
  '手机号和微信号必须填写其中一个': '手机号和微信号必须填写其中一个',
  '处理失败：': '处理失败：',
  '批量导入完成': '批量导入完成',
  '批量导入失败：': '批量导入失败：',
  '请选择要上传的CSV文件': '请选择要上传的CSV文件',
  '文件读取失败，请重新选择': '文件读取失败，请重新选择',
  '文件大小不能超过10MB': '文件大小不能超过10MB',
  '微信号': '微信号',
  '意向度': '意向度',
  '反馈状态': '反馈状态',
  '更新': '更新',
  '国硕代理项目': '国硕代理项目',
  '美国硕博': '美国硕博',
  '新业务硕博': '新业务硕博',
  '硕博在线项目': '硕博在线项目',
  '未处理': '未处理',
  '已存在': '已存在',
  '导出选中': '导出选中',
  '请选择要导出的学生': '请选择要导出的学生',
  '导出成功': '导出成功'
}
